interface TenantFeatures {
  dashboardEnabled: boolean;
  busRouteVisualizationEnabled: boolean;
  coordinateChangeEnabled: boolean;
  entityHistoryEnabled: boolean;
  viewerRoleEnabled: boolean;
}

const defaultFeatures: TenantFeatures = {
  dashboardEnabled: false,
  busRouteVisualizationEnabled: false,
  coordinateChangeEnabled: false,
  entityHistoryEnabled: false,
  viewerRoleEnabled: false,
};

const tenantFeatures: Record<string, TenantFeatures> = {
  'region-sormland': {
    dashboardEnabled: true,
    busRouteVisualizationEnabled: true,
    coordinateChangeEnabled: true,
    entityHistoryEnabled: true,
    viewerRoleEnabled: true,
  },
  'region-vastmanland': {
    dashboardEnabled: true,
    busRouteVisualizationEnabled: true,
    coordinateChangeEnabled: true,
    entityHistoryEnabled: true,
    viewerRoleEnabled: true,
  },
  'region-vasterbotten': {
    dashboardEnabled: true,
    busRouteVisualizationEnabled: true,
    coordinateChangeEnabled: true,
    entityHistoryEnabled: true,
    viewerRoleEnabled: true,
  },
};

export const getTenantFeatures = (tenant: string): TenantFeatures =>
  tenantFeatures[tenant] ?? defaultFeatures;
